<!--
* @description  参数1
* @fileName  paymentDetails
* @author userName
* @date 2024-01-23 16:04:01
!-->
<template>
  <div id="paymentDetails" class="paymentDetails">
    <div class="paymentDetails-title">付款信息</div>
    <div class="paymentDetails-prompt">选择支付方式</div>
    <div class="payment-method">
      <div
        v-for="(item,index) in paymentMethod"
        :key="index"
        :class="['type-class']"
        @click="clickType(item,index)"
      >
        <div v-if="selectNumber == index" class="selected">◉</div>
        <div v-else class="uncheck" />
        <div class="type-name">{{ item.name }}</div>
      </div>
    </div>
    <ByTip
      v-if="payType==2"
      :prompt="`订单号 #`+orderNo+` `"
      :width="964"
      :height="40"
      :color="`#027FFC`"
      :background="`rgba(2,127,252,0.04)`"
      :text-align="'left'"
    />
    <div v-if="payType==2" class="company-billing-details">
      <div class="c-b-d-title">
        <div class="c-b-d-title-l">公司账单详细信息</div>
        <div class="c-b-d-title-r" @click="copyText">复制</div>
      </div>
      <div class="c-b-d-city">
        <div class="c-b-d-city-l"><img :src="data.logo" style="width: 40px;"></div>
        <div class="c-b-d-city-r">
          <div>{{ data.bankNameEn }}</div>
          <div>{{ data.abbreviationEn }}</div>
        </div>
      </div>
      <div class="c-b-d-info">
        <div class="item--medium w352">
          <div class="item-title">收款公司名称</div>
          <div class="item-info">{{ data.companyNameEn }}</div>
        </div>
        <div class="item--medium w556">
          <div class="item-title">收款公司地址</div>
          <div class="item-info">{{ data.companyAddressEn }}</div>
        </div>
        <div class="item--medium w352">
          <div class="item-title">账号</div>
          <div class="item-info">{{ data.accountNo }}</div>
        </div>
        <div class="item--medium w556">
          <div class="item-title">银行名称</div>
          <div class="item-info">{{ data.nameEn }}</div>
        </div>
        <div class="item--medium w100">
          <div class="item-title">银行地址</div>
          <div class="item-info">{{ data.bankAddressEn }}</div>
        </div>
        <div class="item--medium w352">
          <div class="item-title">ABA routing</div>
          <div class="item-info">{{ data.ABARouting }}</div>
        </div>
        <div class="item--medium w556">
          <div class="item-title">Swift code</div>
          <div class="item-info">{{ data.swift }}</div>
        </div>
      </div>

    </div>
    <div class="c-b-d-footer">
      <button v-if="!isPayConfirm&&payType==1" class="button-class" @click="payConfirm(1)">Paypal</button>
      <button v-if="!isPayConfirm&&payType==2" class="button-class" @click="payConfirm(2)">确认支付方式</button>
      <button v-if="isPayConfirm" class="success-btn"><i class="el-icon-success" />已确认支付方式</button>
    </div>
  </div>
</template>

<script>
import { GetDefaultBank } from '@/api/base.js'
import { PayConfirm, GetFbaOrderDetail, CheckOrderComplete } from '@/api/order.js'
import ByTip from '@/components/byTip/byTip.vue'
import * as define from '@/utils/define.js'
export default {
  name: 'PaymentDetails',
  components: {
    // 组件的引用
    ByTip
  },
  props: {
    // 父辈向子辈传参
  },
  data() {
    return {
      paymentMethod: [
        {
          type: 2,
          name: '电子转账'
        }
      ],
      selectNumber: 0,
      payType: 2,
      isPayConfirm: false,
      data: {},
      orderNo: ''
    }
  },
  computed: {
    // 计算属性

  },
  watch: {
    // 监测变化
  },
  created() {
    // 实例被创建之后执行代码
  },
  mounted() {
    // 页面进入时加载内容
  },
  methods: {
    init(orderNo) {
      this.orderNo = orderNo
      this.getBankInfo()
      GetFbaOrderDetail(orderNo).then(res => {
        if (res.code === 200) {
          if (res.data.paymentType && res.data.paymentType > 0) {
            this.isPayConfirm = true
            this.payType = res.data.paymentType
            this.selectNumber = this.payType - 1
          } else {
            this.isPayConfirm = false
            this.payType = 2
          }
        }
      })
    },
    // 方法
    clickType(item, index) {
      this.selectNumber = index
      this.payType = item.type
    },
    getBankInfo() {
      GetDefaultBank().then(res => {
        if (res.code === 200) {
          this.data = res.data
          if (this.data.logo) {
            var json = JSON.parse(this.data.logo)
            if (json.length > 0) {
              this.data.logo = define.comUrl + json[0].url
            } else {
              this.data.logo = undefined
            }
          } else {
            this.data.logo = undefined
          }
        }
      })
    },
    copyText() {
      var text = `收款公司名称:${this.data.companyNameEn}\n收款公司地址:${this.data.companyAddressEn}\n银行卡号:${this.data.accountNo}\n银行名称:${this.data.nameEn}\n银行地址:${this.data.bankAddressEn}\nABA routing:${this.data.ABARouting}\nSwift code:${this.data.swift}`
      try {
        navigator.clipboard.writeText(text)
        this.$message({
          message: 'Copy success',
          type: 'success'
        })
      } catch (err) {}
    },
    payConfirm(type) {
      PayConfirm({
        orderNo: this.orderNo,
        paymentType: type
      }).then(res => {
        if (res.code === 200) {
          CheckOrderComplete(this.orderNo).then(res => {
            if (res.code === 200 && !res.data) {
              this.init(this.orderNo)
            } else {
              this.$emit('next', res.data, 0)
            }
          })
        }
      })
    }
  }
}
</script>
<style scoped lang='scss'>
	.flex1 {
		display: flex;
		align-items: center;
	}

	.j-c-space-between {
		justify-content: space-between;
	}

	.j-c-space-center {
		justify-content: center;
	}

	.font400 {
		font-family: PingFangSC, PingFang SC;
		font-weight: 400;
		color: #777777;
	}

	.font500 {
		font-family: PingFangSC, PingFang SC;
		font-weight: 500;
		color: #333333;
	}

	.paymentDetails {
		width: 964px;
		height: 676px;
		background: #FFFFFF;
		border-radius: 8px;
		padding: 16px;

		.paymentDetails-title {
			font-size: 18px;
			font-family: PingFangSC, PingFang SC;
			font-weight: 600;
			color: #333333;
			text-align: left;
		}

		.paymentDetails-prompt {
			font-size: 14px;
			font-family: PingFangSC, PingFang SC;
			font-weight: 400;
			color: #777777;
			text-align: left;
		}

		.payment-method {
			margin: 15px 0 13px 0;

			.type-class {
				display: flex;
				align-items: center;
				height: 32px;

				.selected {
					width: 18px;
					height: 18px;
					transform: scale(1.6);
					color: #E95506;
				}

				.uncheck {
					width: 16px;
					height: 16px;
					background: rgba(216, 216, 216, 0);
					border-radius: 50%;
					border: 1px solid #DDDDDD;
				}

				.type-name {
					margin-left: 8px;
					font-size: 16px;
					font-family: PingFangSC, PingFang SC;
					font-weight: 400;
					color: #777777;
				}
			}
		}

		.company-billing-details {
			width: 932px;
			height: 376px;
			background: #F5F7FA;
			border-radius: 8px;
			margin-top: 8px;
			padding: 16px;

			.c-b-d-title {
				@extend .flex1;
				@extend .j-c-space-between;

				.c-b-d-title-l {
					@extend .font400;
					font-size: 13px;
				}

				.c-b-d-title-r {
					cursor: pointer;
					font-size: 14px;
					font-family: PingFangSC, PingFang SC;
					font-weight: 400;
					color: #E95506;
				}
			}

			.c-b-d-city {
				@extend .flex1;
				margin: 17px 0 29px 0;

				.c-b-d-city-l {
					width: 40px;
					height: 40px;
					margin-right: 8px;
				}

				.c-b-d-city-r {
					text-align: left;

					div:nth-of-type(1) {
						@extend .font500;
						font-size: 16px;
						margin-bottom: 5px;
					}

					div:nth-of-type(2) {
						@extend .font400;
						font-size: 13px;
					}
				}
			}

			.c-b-d-info {
				display: flex;
				flex-wrap: wrap;

				.w352 {
					width: 352px;
					margin-right: 24px;
				}

				.w556 {
					width: 556px;
				}

				.w100 {
					width: 100%;
				}

				.item--medium {
					float: left;
					text-align: left;
					margin: 11px 0;

					.item-title {
						@extend .font400;
						font-size: 12px;
					}

					.item-info {
						@extend .font500;
						font-size: 13px;
						margin-top: 6px;
					}
				}
			}

		}

		.c-b-d-footer {
			text-align: center;
			margin: 16px 0;
			@extend .flex1;
			justify-content: center;

			i {
				color: #1DB62F;
				margin-right: 8px;
			}

			.success-btn {
				width: 280px;
				height: 40px;
				background: rgba(233, 85, 6, 0);
				border-radius: 8px;
				border: 1px solid #1DB62F;
				@extend .font500;
				font-size: 16px;
			}

			.button-class {
				cursor: pointer;
				width: 280px;
				height: 40px;
				background: #E95506;
				border-radius: 8px;
				border: 1px solid #E95506;
				font-size: 16px;
				font-family: D-DINExp, D-DINExp;
				font-weight: bold;
				color: #FFFFFF;
			}
		}
	}
</style>
